import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";
import { useIsFsEmbedVar } from "@shared/reactiveVar/useIsFsEmbedVar/useIsFsEmbedVar.store";

const INITIAL_STATE = false;

const resetShouldFrontendRefresh = () => {
  shouldFrontendRefreshVar(INITIAL_STATE);
};

const shouldFrontendRefreshVar = makeFSVar(
  INITIAL_STATE,
  "shouldFrontendRefreshVar",
  resetShouldFrontendRefresh
);

const updateShouldFrontendRefresh = (newValue: boolean) => {
  shouldFrontendRefreshVar(newValue);
};

const useShouldFrontendRefresh = () => {
  const shouldRefresh = useReactiveVar(shouldFrontendRefreshVar);
  const isEmbedded = useIsFsEmbedVar();

  return shouldRefresh && !isEmbedded;
};

export { resetShouldFrontendRefresh, updateShouldFrontendRefresh, useShouldFrontendRefresh };
